var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.6402 4.82554C30.1574 1.26687 28.3484 0.66424 24.7897 0.361803C21.7138 0.120974 18.2156 0 15.5015 0C12.7875 0 9.22879 0.120974 6.21338 0.361803C2.6536 0.663119 0.784094 1.26687 0.301316 4.82554C0.119854 6.45421 0 8.68552 0 10.9773C0 13.2691 0.120975 15.5609 0.301316 17.1291C0.784094 20.7482 2.6536 21.2904 6.21226 21.5928C9.22767 21.8941 12.7863 21.9546 15.5004 21.9546C18.2145 21.9546 21.7127 21.8941 24.7886 21.5928C28.3472 21.2915 30.1563 20.7482 30.639 17.1291C30.8799 15.5609 31.0008 13.2691 31.0008 10.9773C31.0008 8.68552 30.8799 6.45421 30.639 4.82554H30.6402ZM12.3652 15.6819V6.33324L20.4469 10.9773L12.3652 15.6819Z","fill":"white"}));
}

SocialYoutube.defaultProps = {"width":"31","height":"22","viewBox":"0 0 31 22","fill":"none"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;
